import { europeanAddresses } from './europeanWorlds'

export const munichBuildingTypes = ['merchant', 'corner', 'courtyard', 'market', 'gallery', 'mansion', 'workshop', 'modern',
  'inn', 'cinema', 'arcade', 'conservatory', 'clockhouse', 'terraces', 'rotunda', 'loft'] as const
export type MunichBuildingType = typeof munichBuildingTypes[number]
const propertyIds=Object.keys(europeanAddresses).map(Number)
export function munichPropertyType(tileId:number){return munichBuildingTypes[Math.max(0,propertyIds.indexOf(tileId))%munichBuildingTypes.length]}

/** Street-facing buildings, with a different architectural mix in each district. */
export function munichParcel(x:number,z:number) {
  let hash=Math.imul(Math.round(x*10),73856093)^Math.imul(Math.round(z*10),19349663)
  hash=Math.imul(hash^(hash>>>16),0x45d9f3b)
  const seed=(hash^(hash>>>16))>>>0
  const mix:readonly MunichBuildingType[]=z < -12
    ? ['merchant','corner','market','mansion','courtyard','inn','cinema','arcade','clockhouse']
    : x > 20
      ? ['workshop','modern','courtyard','corner','market','loft','terraces','conservatory','rotunda']
      : ['clockhouse','mansion','courtyard','merchant','corner','inn','arcade','rotunda','conservatory','gallery','cinema','terraces','loft']
  const roads=[{distance:Math.abs(x+15.2),angle:x < -15.2?Math.PI/2:-Math.PI/2},
    {distance:Math.abs(x-15.2),angle:x < 15.2?Math.PI/2:-Math.PI/2},
    {distance:Math.abs(z+39),angle:z < -39?0:Math.PI},
    {distance:Math.abs(z-39),angle:z < 39?0:Math.PI}]
  roads.sort((a,b)=>a.distance-b.distance)
  return {type:mix[seed%mix.length],seed,rotation:roads[0].angle}
}
